export function buildAsociarUsuarioVentaResponse(responseAsociarUsuarioVenta) {
    return {
        respuestaOK: responseAsociarUsuarioVenta.respuestaOK,
        codigo: responseAsociarUsuarioVenta.codigoRespuesta,
        mensaje: responseAsociarUsuarioVenta.mensajeRespuesta
    }
}